export default __webpack_public_path__ + "static/media/Complaint-Resolution-Procedure-RadioRentals-digi-March-2023.f41e1be4.pdf";